import * as React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import styled, { css } from 'styled-components'
import { constVoid, E, identity, O, pipe, s, tt } from '@packages/prelude'

export interface FilterItemProps {
  onClick: () => void
  name: string
  icon: O.Option<string>
  active: boolean
}

const ActiveState = css`
  color: var(--bs-primary);
  &:hover {
    color: var(--bs-primary) !important;
  }
`

const Item = styled.a<{ active: boolean }>`
  ${props => props.active && ActiveState}
`

export const FilterItem: React.VFC<FilterItemProps> = ({ icon: _icon, name, onClick, active }) => {
  const icon = pipe(_icon, E.fromOption(constVoid), E.chainW(tt.NonEmptyString.decode), E.foldMap(s.Monoid)(identity))
  return (
    <OverlayTrigger overlay={<Tooltip id={`tooltip-${name}`}>{name}</Tooltip>}>
      <Item className="btn btn-lg btn-filter" onClick={onClick} active={active}>
        <i className={icon}></i>
        <span className="visually-hidden">{name}</span>
      </Item>
    </OverlayTrigger>
  )
}
